<template>
  <span >
     {{nickname}}
  </span>
</template>

<script>
export default {
  props: ["uid"],
  data:function(){
    return {
      nickname:'',
    }
  },
  watch:{
    uid:function(newVal,oldVal){
      console.log("watch",newVal,oldVal)
      if( (!oldVal)  && newVal){
          this.getInfo();
      }
    }
  },
  methods:{
      getInfo:function(){
          var app = this;
          console.log("getNick",app.uid)
          app.axios.post("/userCache",{
              uid:app.uid,
          })
              .then(function(res){
                  if(res.data.errcode=="suc"){
                      app.nickname = res.data.data.nickname;
                  }
                  else{
                    app.nickname = app.uid
                  }
              })
                  .catch(function(){
                    app.nickname = app.uid
                  })
      },
  },
  mounted:function(){
    this.getInfo();
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  .van-uploader__upload-text{
    color:#43b292;
    font-size: 12px;
  }
  .van-uploader__upload-icon{
    color:#43b292;
  }
  .van-icon-plus:before{
    font: 14px/1 "FontAwesome";
    font-size: 18px;
    content: "\f0fe"
  }
</style>
